import FamilyResourcesPage from './components/FamilyResourcesPage';

const Reports: React.FC = () => {
  return <FamilyResourcesPage />;
};

export default Reports;
